import { createResponseTransformer } from "shared/api/createResponseTransformer"
import { serializer } from "shared/api/serializer/serializer"
import { transformJsonApiResponse } from "shared/api/transformJsonApiResponse"
import { AttachmentAcceptedFileTypesAPIType } from "shared/types/Attachment"

export const attachmentAcceptedFileTypesResponseTransformer =
  createResponseTransformer(json => {
    return serializer.deserialize(
      AttachmentAcceptedFileTypesAPIType,
      transformJsonApiResponse(json)
    )
  })
